import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import React, { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from 'react';

import { cn } from '@tectonics/utils/utils';

const labelVariants = cva(
  'flex flex-row peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  {
    variants: {
      lookAndFeel: {
        default: 'text-label-fg font-bold',
        volcanes: 'text-label-fg text-sm',
        shopify: 'text-label-fg',
      },
      size: {
        sm: 'text-xs',
        lg: 'text-sm',
      },
    },
    compoundVariants: [
      { lookAndFeel: 'shopify', size: 'lg', class: 'text-[12.6px]' },
    ],
    defaultVariants: {
      lookAndFeel: 'default',
      size: 'lg',
    },
  }
);

const Label = forwardRef<
  ElementRef<typeof LabelPrimitive.Root>,
  ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants>
>(({ className, lookAndFeel = 'default', size, children, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants({ lookAndFeel, size }), className)}
    {...props}
    data-look-and-feel={lookAndFeel}
  >
    {children}
  </LabelPrimitive.Root>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
